<div class="user-area-wrapper">
  <opac-user-title [title]="'interests.title' | translate"></opac-user-title>

  <div class="user-interests">
    <div *ngFor="let question of questions; let i = index" class="user-interests__section">
      <h2 class="user-interests__section__title">{{ question.title }}</h2>
      <p class="user-interests__section__text">{{ question.description }}</p>

      <ng-container *ngIf="question.type === 'RADIOBUTTON'">
        <app-radio-question
          [question]="question"
          [showEveryLevelAtOnce]="true"
          (selected)="onSelected()"></app-radio-question>
      </ng-container>

      <ng-container *ngIf="question.type === 'TAGS'">
        <app-tag-question [question]="question" (selected)="onSelected()"></app-tag-question>
      </ng-container>
    </div>

    <button (click)="onSubmit()" [disabled]="!validForm" mat-flat-button class="accent user-interests__save">
      {{ 'common.saveChanges' | translate }}
    </button>
  </div>
</div>
